import { html } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
export const datatableHeaderTemplate = html `<template role="rowgroup"
  ><slot></slot
></template>`;
export class DataTableHeaderComponent extends ChameleonElementMixin(FoundationElement) {
}
